(function () {
  'use strict';

  function setup(button) {
    if (!button || button.dataset.calcDetailsReady === 'true') return;
    var shell = document.getElementById(button.getAttribute('aria-controls'));
    if (!shell) return;

    var layout = button.closest('.cc__layout');
    var label = button.querySelector('[data-calc-details-label]');
    var readMoreLabel = button.dataset.readMoreLabel || 'Read More';
    var showLessLabel = button.dataset.showLessLabel || 'Show Less';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var expanded = false;
    button.dataset.calcDetailsReady = 'true';
    shell.classList.add('is-ready');

    function previewLimit() {
      return parseFloat(getComputedStyle(shell).getPropertyValue('--cc-preview-limit')) || 520;
    }

    function updateAvailability() {
      if (expanded) return;
      var hasMore = shell.scrollHeight > previewLimit() + 8;
      button.hidden = !hasMore;
      shell.classList.toggle('is-short', !hasMore);
      if (layout) layout.classList.toggle('is-collapsed', hasMore);
    }

    function finishTransition() {
      if (expanded) shell.style.maxHeight = 'none';
    }

    button.addEventListener('click', function () {
      expanded = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? showLessLabel : readMoreLabel;

      if (expanded) {
        shell.style.maxHeight = previewLimit() + 'px';
        shell.classList.add('is-expanded');
        if (layout) layout.classList.remove('is-collapsed');
        window.requestAnimationFrame(function () {
          shell.style.maxHeight = shell.scrollHeight + 'px';
          if (reducedMotion.matches) finishTransition();
        });
      } else {
        shell.style.maxHeight = shell.scrollHeight + 'px';
        shell.classList.remove('is-expanded');
        if (layout) layout.classList.add('is-collapsed');
        shell.offsetHeight;
        window.requestAnimationFrame(function () {
          shell.style.maxHeight = previewLimit() + 'px';
          button.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
        });
      }
    });

    shell.addEventListener('transitionend', function (event) {
      if (event.propertyName === 'max-height') finishTransition();
    });
    window.addEventListener('resize', updateAvailability);
    updateAvailability();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-calc-details-toggle]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
